<template>
  <div class="admin">
    <Menu />
    <PaymentDetails ref="details" />
    <CollapsibleBox>
      <template #title>
        Validation non capturés
      </template>
      <template #content>
        <NonCaptures />
      </template>
    </CollapsibleBox>
  </div>
</template>

<script>
import Menu from "@/components/admin/Menu.vue";
import CollapsibleBox from "../util/CollapsibleBox.vue";
import NonCaptures from "./paiements/NonCaptures.vue";
import PaymentDetails from "./paiements/PaymentDetails.vue";

export default {
  name: "AdminVerif",
  components: { Menu, CollapsibleBox, NonCaptures, PaymentDetails },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (to.query.ref) {
        if (vm.$refs.details) {
          vm.$refs.details.loadRef(to.query.ref);
        }
      }
    });
  }
};
</script>

<style scoped lang="scss"></style>
